function getBaseURL() {
    if (process.env.NODE_ENV === "production") {
        return "https://lgapi-dev.musea2.azure.ext.gm.com";
    } else {
        return "http://localhost:8000";
    }
}

export const BASEURL = getBaseURL();